import React, { Component  } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable, MDBCard, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card,Tooltip  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
//import ModelDescription from './ModelDescription';
import { api, URL } from '../../api';
import Modelshowstudent from './Modelshowstudent';
import Moment from 'react-moment';
//import ModelRegister from './ModelRegister';


//import Modaladdcurriculumopen from './Modaladdcurriculumopen';
//import Modeltest from './Modeltest';
//import Modaladdteacher from './Modaladdteacher';


export default class Teachermain extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          modal: false,
         
          type:'1',
        
          year:'2564',
          search: '',

          Curriculum:[],
          Studentcb_ID:'',
          Citizen:'',


   
          Course_ID:'',
          Course_Name_TH:'',
          Course_Name_En:'',
          Course_Credit:'',
          Course_Year:'',
          Course_T_Hour:'',
          Course_Detail_TH:'',
          Course_Detail_EN:'',

          pagination: {
            current: 1,
            pageSize: 20,
          },

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onChange = this.onChange.bind(this);


        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.getCitizenstu = this.getCitizenstu.bind(this);
        this.linkto = this.linkto.bind(this);
        
      }


      onChange(value) {
        
           const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
         //  const idemp = value;
         //  console.log(Courseselect[0].Course_ID);
           this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
           this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
           this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
           this.setState({ Course_Credit : Courseselect[0].Course_Credit });
           this.setState({ Course_Year : Courseselect[0].Course_Year });
           this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
           this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
           this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });

           this.getCurriculumopen()

        }

        //ดึงหลักสูตรที่เปิดสอน
        getCurriculumopen() {
          setTimeout(() => {
             //ภายใน
             api.get('index/getCurriculumopen/'+this.state.Course_ID)
             .then(res => {
             //  console.log(res);
             //  this.setState({ bankname: res.data, loading: false })
               this.setState({ Curriculumopen: res.data})
             }) 
           }, 0);
      }


      
      linkto(event) {
          console.log(event.target.value)
          const id = event.target.value;

          window.location.href = '/creditbank/Teachercuriculum/'+id;
          // setTimeout(() => {
          //    //ภายใน
          //    api.get('index/getCurriculumopen/'+this.state.Course_ID)
          //    .then(res => {
          //    //  console.log(res);
          //    //  this.setState({ bankname: res.data, loading: false })
          //      this.setState({ Curriculumopen: res.data})
          //    }) 
          //  }, 0);
      }

  

      getCitizenstu() {
        setTimeout(() => {
           //ภายใน
           api.get('index/getCitizenstu/'+localStorage.getItem('Studentcb_ID'))
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ Citizen: res.data[0].Studentcb_Citizen_ID})
           }) 
         }, 0);
       }


      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

 
         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }


          componentDidMount(){
           
            this.setState({ Studentcb_ID:localStorage.getItem('Studentcb_ID')}) 

            if (localStorage.getItem('name') == null) {
               
                 // window.location.href = 'https://e-student.kpru.ac.th/vaccinekpru'
               
            } else {
        
            }
                      api.get('index/getCurriculumforteacher/'+ localStorage.getItem('Citizen_ID'),
                   //     Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                       
                          const Curriculum = res.data;
                          this.setState({ Curriculum });
                      })    
               // this.getCitizenstu()  ;   
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };


    render() {

        console.log(this.state.Course_ID)
      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const {  pagination } = this.state;
     
      
      const { Option } = Select;
     // const newDate = moment(new Date()).format("DD/MM/YYYY");
     // const newDate = new Date("MM/DD/YYYY");
     const date = new Date();
     const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
     const dates = year+"-"+month+"-"+day ;
     // console.log(dates);
     const text = <span>หลักสูตรจะแสดงเมื่อมีการเพิ่มผู้สอนในหลักสูตร </span>;
       
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
    
        {/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
        <Card type="inner"  style={{ marginTop: 0 }}  headStyle={{ backgroundColor: '#dfdcdcff', color: '#ffffff' }} title={<h4><MDBIcon icon="list-alt" /> หน้าหลัก อาจารย์ผู้สอน</h4> } extra={<a href="#"><p>อาจารย์{localStorage.getItem('name')}</p></a>} >

            {/* <MDBRow>
                    <MDBCol sm="6">
                ค้นหารายวิชา  
                    <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกวิชา"
                            optionFilterProp="children"
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                           
                        
                        {this.state.Curriculum.map((Curriculum,index )  => 
                        <option value={Curriculum.Curriculumopen_ID}>{Curriculum.Curriculumopen_Full_Name_TH}</option>
                        )}
                        </Select>
                    </MDBCol>

                    <MDBCol sm="4">
                      
                    </MDBCol> 
            </MDBRow> */}

                        {/* <Breadcrumb>
                          <Breadcrumb.Item>หน้าหลัก  </Breadcrumb.Item>
                         
                        </Breadcrumb>
                        <br/> */}

                 <MDBRow>
                 
                        <MDBCol sm="12">
       
                            <MDBJumbotron fluid>
                              
                            <MDBContainer fluid>
                            <h2 className="display-5 deep-purple-text text-center">หลักสูตรที่เปิดสอน    
                            </h2> 
                            <p className="text-right">
                               <Tooltip placement="top" title={text} color="orange">
                                        <MDBIcon icon="question-circle" size="lg" />
                                    </Tooltip> 
                            </p>
                          
                                {/* <h4 className="display-5 deep-purple-text">รายละเอียดวิชา</h4> */}
                                <MDBCol>
                                {this.state.Curriculum.map((Curriculum,index) => { 
                                 
                                return  <MDBCard style={{ width: "100%" }} className="mt-2">
                                            {/* <MDBCardImage className="img-fluid" src="https://mdbootstrap.com/img/Photos/Others/images/43.jpg" waves /> */}
                                            <MDBCardBody>

                                                <MDBRow>
                                                  <MDBCol size="0.5">
                                                    {Curriculum.Curriculumopen_Date_ENDRE < dates ?<> <MDBIcon icon="atlas" size="2x" /></>:<><MDBIcon icon="lock" size="2x" /> </> }
                                                  
                                                  </MDBCol>
                                                  <MDBCol size="5">
                                                      <MDBCardTitle> ชื่อหลักสูตร : {Curriculum.Curriculumopen_Full_Name_TH} </MDBCardTitle>
                                                       <MDBCardText>
                                                        ชื่อภาษาอังกฤษ : {Curriculum.Curriculumopen_Full_Name_EN} 
                                                      </MDBCardText>
                                                      <MDBCardText>
                                                        เทอม {Curriculum.Curriculumopen_TEAM} จำนวน {Curriculum.Curriculumopen_CH}  ชั่วโมง
                                                      </MDBCardText>
                                                      <MDBCardText>
                                                        ช่วงเวลาสอน {Curriculum.Curriculumopen_Date_START} ถึง {Curriculum.Curriculumopen_Date_END}  
                                                      </MDBCardText>
                                                      <MDBCardText>
                                                        เพิ่มข้อมูลโดย : อาจารย์{Curriculum.Teacher_NAME}  {Curriculum.Teacher_LASTNAME}  
                                                      </MDBCardText>
                                                      <MDBCardText>
                                                         {Curriculum.Curriculumopen_Approve_Dean === null?<>
                                                         {Curriculum.Curriculumopen_Approve_Cu === null ?<>
                                                          <p className="orange-text"> <MDBIcon icon="sync" /> [รองานหลักสูตรอนุมัติ]</p>
                                                         </>:<>
                                                         <p className="orange-text"><MDBIcon icon="sync" /> [รอคณบดีอนุมัติ]</p>
                                                         </>}
                                                        
                                                         
                                                         </> :<>{Curriculum.Curriculumopen_Approve_Dean === '2'? <><p className="green-text"><MDBIcon far icon="check-circle" /> [อนุมัติแล้ว]</p></>:<><p className="pink-text">[ไม่อนุมัติ]</p></>} </>} 
                                                      </MDBCardText>
                                                  </MDBCol>
                                                  <MDBCol size="5">
                                                    {Curriculum.Curriculumopen_Approve_Dean === '2' ?<>
                                                    
                                                     <Modelshowstudent Curriculumopen_ID ={Curriculum.Curriculumopen_ID} Curriculumopen_Full_Name_TH ={Curriculum.Curriculumopen_Full_Name_TH} /> 
                                                  {Curriculum.Curriculumopen_Approve_grade === "2" ? <><MDBBtn color="unique">เสร็จสิ้น</MDBBtn></>:<>
                                                  <MDBBtn value={Curriculum.Curriculumopen_ID}  onClick={this.linkto} >ลงทะเบียนผู้เรียน</MDBBtn></>}
                                                    </>:<>
                                                    <MDBIcon icon="sync" /> อยู่ระหว่างพิจารณา
                                                    </>}
                                                 
                                
                                                  {/* <MDBBtn color="secondary">Download</MDBBtn> */}
                                                  </MDBCol>
                                                </MDBRow>
                                          
                                                {/* <Moment parse="YYYY-MM-DD HH:mm">
                                                    1976-04-19 12:59
                                                </Moment> */}
                                           
                                            {/* <MDBBtn href="#">รายละเอียดหลักสูตร</MDBBtn>
                                            <MDBBtn color="secondary">รายละเอียดหลักสูตร</MDBBtn> */}  
                                            
                                            </MDBCardBody>
                                        </MDBCard>
                                })}  

                                </MDBCol>
                            </MDBContainer>
                            </MDBJumbotron>    
                      
                        </MDBCol>
                 </MDBRow>

        </Card>
            </MDBContainer>
        )
    }
}
